<template>
    <div>
        <label class="block text-sm font-medium leading-5 text-gray-800 relative"
            :class="{'required': required}"
            :for="name"
            v-if="label">
            <span v-html="label"></span>
            <font-awesome-icon class="text-xs text-black ml-1 cursor-pointer"
                :icon="['fas', 'question-circle']"
                style="margin-top: 2px;"
                v-if="tooltip" v-tooltip="tooltip" />
        </label>
        <div class="mt-1">
            <ValidationProvider :name="providerName ? providerName : label" mode="passive" :rules="rules" v-slot="{ errors }" tag="div">
                <div class="mt-1" :class="['input-'+suffix ]">
                    <verte v-if="mounted" :value="value" @input="update" model="hex" picker="square" menuPosition="right"></verte>
                </div>
                <span class="text-xs text-red-700 absolute">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
    </div>
</template>

<script>
    import Verte from 'verte';
    import 'verte/dist/verte.css';

    export default {
        name: "InputColour",
        components: {
            Verte
        },
        props: ['label', 'value', 'name', 'providerName', 'rules', 'required', 'tooltip', 'disabled', 'suffix'],
        data: function(){
            return {
                model: null,
                mounted: false,
            }
        },
        mounted() {
            if (this.value){
                this.model = this.value;
            }
            this.mounted = true
        },
        methods: {
            update (payload){
                this.$emit('input', payload);
            }
        },
        watch: {
            value: function(newVal){
                this.model = newVal;
                this.$emit('input', newVal);
            },
        }
    }
</script>

<style>
    .verte {
        justify-content: start!important;
    }

    .verte__guide {
        width: 38px!important;
        height: 38px!important;
        border: 1px solid #ccc;
        border-radius: 20px;
    }
</style>
